import React from 'react'
import { darken } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';

import {
  ContentState,
  ContentBlock,
} from 'draft-js'

import {
  IData_MagicTag_Type,
} from '@kaidam/fc-shared/src/types/schema/magic_tag'

import {
  ITextEditor_Entity_MagicTag,
} from '@kaidam/fc-shared/src/types/texteditor'

import {
  MAGICTAG_COLORS,
  TEXT_EDITOR_ENTITY_TYPE_MAGICTAG,
} from '@kaidam/fc-shared/src/constants'

import MagicTagIcon from '../MagicTagIcon'

const strategy = (
  contentBlock: ContentBlock,
  callback: {
    (start: number, end: number): void,
  },
  contentState: ContentState,
) => {
  contentBlock.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity()
      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === TEXT_EDITOR_ENTITY_TYPE_MAGICTAG
      )
    },
    callback
  )
}

const useStyles = makeStyles(theme => ({
  root: ({color}:any) => ({
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    borderRadius: '20px',
    color: '#666',
    border: `1px solid ${color}`,
    whiteSpace: 'nowrap',
    boxShadow: '2px 2px 5px 0px rgba(0,0,0,0.3)'
  }),
  icon: ({color}:any) => ({
    color: color,
    fontSize: '0.7em',
  }),
}))

const component = (props: any) => {
  const entity = props.contentState.getEntity(props.entityKey).getData() as ITextEditor_Entity_MagicTag
  const type = entity.type
  const classes = useStyles({
    color: MAGICTAG_COLORS[type],
  })
  return (
    <span className={ classes.root }>
      <MagicTagIcon className={ classes.icon } type={ type } avatar={ false } />&nbsp;
      { props.children }
    </span>
  )
}

const magicTagDecorator = {
  strategy,
  component,
}

export default magicTagDecorator